/* ============
 * Actions for the alert module
 * ============
 *
 * The actions that are available on the
 * alert module.
 */
import Vue from 'vue';
import AlertProxy from '@/proxies/AlertProxy';
import message from '@/constants/_message';
import types from './mutation-types';


export const view = ({ commit }, data) => {
  commit(types.FETCH_ALERTS);
  new AlertProxy().view(data)
    .then((response) => {
      commit(types.FETCH_ALERTS_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_ALERTS_FAIL, error);
    });
};

export const update = ({ commit }, data) => {
  commit(types.UPDATE_ALERT);
  new AlertProxy().update(data)
    .then((response) => {
      commit(types.UPDATE_ALERT_SUCCESS, response);
      Vue.notify({
        group: 'notification',
        title: 'Success',
        text: message.ALERT_UPDATED,
        type: 'success'
      });
    }).catch((error) => {
      commit(types.UPDATE_ALERT_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: message.ALERT_NOT_UPDATED,
        type: 'error'
      });
    });
};

export const resolve = ({ commit }, { formData, isCompleted, successCb }) => {
  commit(types.RESOLVE_ALERT);
  new AlertProxy().resolve(formData)
    .then((response) => {
      commit(types.RESOLVE_ALERT_SUCCESS, response);
      if (isCompleted) {
        successCb();
        Vue.notify({
          group: 'notification',
          title: 'Success',
          text: message.ALERT_RESOLVED,
          type: 'success'
        });
      }
    }).catch((error) => {
      commit(types.RESOLVE_ALERT_FAIL, error);
      if (isCompleted) {
        Vue.notify({
          group: 'notification',
          title: 'Error',
          text: message.ALERT_NOT_RESOLVED,
          type: 'error'
        });
      }
    });
};

export const setAlerts = ({ commit }, alerts) => {
  commit(types.SET_ALERTS, alerts);
};

export const persistAlert = ({ commit }, { index, value }) => {
  commit(types.PERSIST_ALERT, { index, value });
};

export const getResolvedNotes = ({ commit }, data) => {
  commit(types.FETCH_RESOLVED_NOTES);
  new AlertProxy().getResolvedNotes(data)
    .then((response) => {
      commit(types.FETCH_RESOLVED_NOTES_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_RESOLVED_NOTES_FAIL, error);
    });
};

export default {
  view,
  update,
  resolve,
  setAlerts,
  persistAlert,
  getResolvedNotes
};
